import React from "react";
import { useNavigate } from "react-router-dom";

const Tabs = ({ tab, setTab }) => {
  const navigate = useNavigate();

  const allTabs = [
    {
      name: "Account Settings",
      query: "account-settings",
      icon: <img src={require("../../../assets/images/user.svg")} alt="" />,
      activeIcon: (
        <img src={require("../../../assets/images/activeUser.svg")} alt="" />
      ),
      details: "Manage your user account details and campaign details",
    },
    {
      name: "Roles",
      query: "roles",
      icon: <img src={require("../../../assets/images/roles.svg")} alt="" />,
      activeIcon: (
        <img src={require("../../../assets/images/activeRoles.svg")} alt="" />
      ),
      details:
        " Invite, add admins and sub admins, agents, and assign roles on on your company team",
    },
  ];

  return (
    <div className="grid md:gap-8 gap-4 md:mb-0 mb-8">
      {allTabs.map((item, index) => (
        <div
          onClick={() => {
            navigate("/settings?q=" + item.query, { replace: true });
            // setTab(item.name);
          }}
          key={index}
          className=" cursor-pointer p-[32px] bg-white shadow"
        >
          <div className="flex items-center gap-3">
            {tab === item.query ? item.activeIcon : item.icon}

            <p
              className={
                tab === item.query ? "text-[#3989DD]" : "text-[#313232]"
              }
            >
              {item.name}
            </p>
          </div>
          <p className="text-sm text-[#787878] mt-3">{item.details}</p>
        </div>
      ))}
    </div>
  );
};

export default Tabs;
